import React, { createContext, useContext, useState } from 'react';
import './QuestionnairePrompt.css';

const QuestionnairePromptContext = createContext();

export const useQuestionnairePrompt = () => {
  const context = useContext(QuestionnairePromptContext);
  if (!context) {
    throw new Error('useQuestionnairePrompt must be used within QuestionnairePromptProvider');
  }
  return context;
};

const QuestionnairePromptContent = ({ prompt, setPrompt }) => {
  const handleGoToQuestionnaire = () => {
    if (prompt && prompt.sport) {
      window.location.href = `/questionnaire?sport=${encodeURIComponent(prompt.sport)}`;
    } else {
      window.location.href = '/questionnaire';
    }
    setPrompt(null);
  };

  if (!prompt) return null;

  return (
    <div className="questionnaire-prompt-overlay" onClick={() => setPrompt(null)}>
      <div className="questionnaire-prompt-modal" onClick={(e) => e.stopPropagation()}>
        <div className="questionnaire-prompt-content">
          <div className="questionnaire-prompt-icon">📋</div>
          <h2 className="questionnaire-prompt-title">Complete Questionnaire</h2>
          <div className="questionnaire-prompt-message">
            <p>You need to complete the questionnaire for <strong>{prompt.sport}</strong> before you can express interest in leagues for this sport.</p>
            <p>The questionnaire helps us determine your skill level and match you with appropriate players.</p>
          </div>
        </div>
        <div className="questionnaire-prompt-actions">
          <button className="btn btn-secondary" onClick={() => setPrompt(null)}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleGoToQuestionnaire}>
            Go to Questionnaire
          </button>
        </div>
      </div>
    </div>
  );
};

export const QuestionnairePromptProvider = ({ children }) => {
  const [prompt, setPrompt] = useState(null);

  const showQuestionnairePrompt = (sport) => {
    setPrompt({ sport });
  };

  return (
    <QuestionnairePromptContext.Provider value={{ showQuestionnairePrompt }}>
      {children}
      <QuestionnairePromptContent prompt={prompt} setPrompt={setPrompt} />
    </QuestionnairePromptContext.Provider>
  );
};

